import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from '../../util/reactIntl';
import classNames from 'classnames';
import { ACCOUNT_SETTINGS_PAGES, isAdminNavSelected } from '../../routing/routeConfiguration';
import { LinkTabNavHorizontal } from '../../components';

import css from './UserNav.module.css';
import { useSelector } from 'react-redux';
import { abilityToSell, USER_TYPE_YOUTH } from '../../util/types';
import { currentUserRole, getUserPermissions } from '../../util/data';

const UserNav = props => {
  const { currentUser } = useSelector(state => state.user);
  const { publicData, protectedData, privateData } = (currentUser && currentUser.id && currentUser.attributes?.profile) || {};
  const { userRole, parentId = false } = publicData || {};
  const { subscriptionData = false } = protectedData || {};
  const { isOrganizationAdmin, isSupabaseAdmin, isWalletAdmin, isModAdmin, isUserAdmin, isShopifyAdmin, isHighlightAdmin, isDiscoverGroupsCarouselAdmin, isDiscountAdmin } = privateData || {}
  const { className, rootClassName, currentPage } = props;
  const classes = classNames(rootClassName || css.root, className);
  const userSubscriptionRole = currentUserRole(currentUser);
  const userAbilityToSell = getUserPermissions(userSubscriptionRole, abilityToSell);
  const defaultAdminLinkProps = isOrganizationAdmin
    ? { name: 'AdminPanelOrganisationPage' }
    : isSupabaseAdmin
    ? { name: 'AdminPanelSupabasePage', params: { tab: 'general' } }
    : isModAdmin
    ? { name: 'AdminPanelModeratorsPage', params: { tab: 'general' } }
    : isWalletAdmin
    ? { name: 'AdminPanelWalletPage' }
    : isShopifyAdmin
    ? { name: 'AdminPanelShopifyFeeReportPage' }
    : isUserAdmin
    ? { name: 'AdminPanelUserPage' }
    : isHighlightAdmin
    ? { name: 'AdminPanelHighlightsPage' }
    : isDiscoverGroupsCarouselAdmin
    ? { name: 'AdminPanelDiscoverGroupsCarouselsPage' }
    : { name: 'AdminPanelDiscountCodesPage' };


  const tabs = [
    {
      text: <FormattedMessage id="UserNav.stripeSubscriptionPage" />,
      selected: currentPage === 'StripeSubscriptionPage',
      linkProps: {
        name: 'StripeSubscriptionPage',
      },
    },
    {
      text: <FormattedMessage id="UserNav.profileSettings" />,
      selected: currentPage === 'ProfileSettingsPage',
      disabled: false,
      linkProps: {
        name: 'ProfileSettingsPage',
      },
    },
    {
      text: <FormattedMessage id="UserNav.accountSettings" />,
      selected: ACCOUNT_SETTINGS_PAGES.includes(currentPage),
      disabled: false,
      linkProps: {
        name: 'ContactDetailsPage',
      },
    },
  ];

  if (userRole !== USER_TYPE_YOUTH && (subscriptionData || !parentId) && userAbilityToSell) {
    tabs.push({
      text: <FormattedMessage id="UserNav.yourListings" />,
      selected: currentPage === 'ManageListingsPage',
      linkProps: {
        name: 'ManageListingsPage',
      },
    })
  }


  // tabs.push({
  //     text: <FormattedMessage id="LayoutWrapperAccountSettingsSideNav.AdminPanelOrganisationPageTabTitle" />,
  //     selected: isAdminNavSelected.includes[currentPage]  === 'AdminPanelOrganisationPage',
  //     id: 'AdminPanelOrganisationPage',
  //     linkProps: {
  //       name: 'AdminPanelOrganisationPage',
  //     },
  //     isDropdown: true,
  //   })

  if (isOrganizationAdmin || isSupabaseAdmin || isWalletAdmin || isModAdmin || isUserAdmin || isShopifyAdmin || isHighlightAdmin || isDiscoverGroupsCarouselAdmin || isDiscountAdmin) {
    tabs.unshift({
      text: <FormattedMessage id="LayoutWrapperAccountSettingsSideNav.AdminPanelTitle" />,
      selected: isAdminNavSelected.includes(currentPage),
      id: defaultAdminLinkProps.name,
      linkProps: defaultAdminLinkProps,
      isDropdown: true,
      subTabs: [
        ...(isOrganizationAdmin ? [{
          text: <FormattedMessage id="LayoutWrapperAccountSettingsSideNav.AdminPanelOrganisationPageTabTitle" />,
          selected: currentPage === 'AdminPanelOrganisationPage',
          linkProps: {
            name: 'AdminPanelOrganisationPage',
          },
        }] : []),
        ...(isSupabaseAdmin ? [{
          text: <FormattedMessage id="TopbarDesktop.adminPanelLink" />,
          selected: currentPage == 'AdminPanelSupabasePage',
          linkProps: {
            name: 'AdminPanelSupabasePage',
            params: { tab: "general" },
          },
        }] : []),
        ...(isModAdmin ? [{
          text: <FormattedMessage id="TopbarDesktop.adminPanelModeratorLink" />,
          selected: currentPage == 'AdminPanelModeratorsPage',
          linkProps: {
            name: 'AdminPanelModeratorsPage',
            params: { tab: "general" },
          },
        }] : []),
        ...(isWalletAdmin ? [{
          text: <FormattedMessage id="LayoutWrapperAccountSettingsSideNav.AdminPanelWalletPage" />,
          selected: currentPage === 'AdminPanelWalletPage',
          linkProps: {
            name: 'AdminPanelWalletPage',
          },
        }] : []),
        // ...(isShopifyAdmin ? [{
        //   text: <FormattedMessage id="LayoutWrapperAccountSettingsSideNav.AdminPanelShopifyFeeReportPage" />,
        //   selected: currentPage === 'AdminPanelShopifyFeeReportPage',
        //   linkProps: {
        //     name: 'AdminPanelShopifyFeeReportPage',
        //   },
        // }] : []),
        ...(isUserAdmin ? [{
          text: <FormattedMessage id="LayoutWrapperAccountSettingsSideNav.AdminPanelUserPage" />,
          selected: currentPage == 'AdminPanelUserPage',
          linkProps: {
            name: 'AdminPanelUserPage',
          },
        }] : []),
        ...(isHighlightAdmin ? [{
          text: <FormattedMessage id="LayoutWrapperAccountSettingsSideNav.AdminPanelHighlightsPage" />,
          selected: ['AdminPanelHighlightsPage', 'AdminPanelHighlightCategoryPage'].includes(currentPage),
          linkProps: {
            name: 'AdminPanelHighlightsPage',
          },
        }] : []),
        ...(isDiscoverGroupsCarouselAdmin ? [{
          text: <FormattedMessage id="LayoutWrapperAccountSettingsSideNav.AdminPanelDiscoverGroupsCarouselsPage" />,
          selected: currentPage === 'AdminPanelDiscoverGroupsCarouselsPage',
          linkProps: {
            name: 'AdminPanelDiscoverGroupsCarouselsPage',
          },
        }] : []),
        ...(isDiscountAdmin ? [{
          text: 'Discount Codes',
          selected: currentPage === 'AdminPanelDiscountCodesPage',
          linkProps: {
            name: 'AdminPanelDiscountCodesPage',
          },
        }] : []),
      ],
    })
  };
  return (
    <LinkTabNavHorizontal className={classes} tabRootClassName={css.tab} tabs={tabs} skin="dark" />
  );
};

UserNav.defaultProps = {
  className: null,
  rootClassName: null,
};

const { string } = PropTypes;

UserNav.propTypes = {
  className: string,
  rootClassName: string,
  currentPage: string.isRequired,
};

export default UserNav;
